import {store} from './store';
import {configConst, setConfig} from './config-manager';
import {isConnected, onConnect, onDisconnect} from '../em-shared-session/src/connection';

/**
 * Connection
 */
import {setDefaultConnectionSettings, updateConnectionSettings} from './enhanced-webapi/connection';

// Defaults
const connectionDefaults = {
    webapiEndpoint: 'wss://sports-banner.everymatrix.com/v2',
    webapiFallbackEndpoint: 'https://sports-banner.everymatrix.com/longpoll',
    webapiDomain: '',
};

// Set Default Connection Settings
(() => {
    const currentState = store.getState()[configConst.STORE_PART];
    const {webapiEndpoint, webapiFallbackEndpoint, webapiDomain} = Object.assign({}, connectionDefaults, currentState);
    if (
        webapiEndpoint !== currentState.webapiEndpoint ||
        webapiFallbackEndpoint !== currentState.webapiFallbackEndpoint ||
        webapiDomain !== currentState.webapiDomain
    ) {
        store.dispatch(setConfig({webapiEndpoint, webapiFallbackEndpoint, webapiDomain}));
    }
    setDefaultConnectionSettings(webapiEndpoint, webapiFallbackEndpoint, webapiDomain);
})();

// React To Configuration Changes
store.subscribe(() => {
    const {webapiEndpoint, webapiFallbackEndpoint, webapiDomain} = store.getState()[configConst.STORE_PART];
    updateConnectionSettings(webapiEndpoint, webapiFallbackEndpoint, webapiDomain);
});


/**
 * Enhanced Web API
 */
import api from './enhanced-webapi/api';

export {api};
export {onTx, onRx} from './enhanced-webapi/tx-rx';


/**
 * OperatorInfo
 */
let operatorInfoCallId = '';
function performOperatorInfoRequest() {
    operatorInfoCallId = api.createClientRequestId();
    api.requestOperatorInfo({
        clientRequestId: operatorInfoCallId,
        onSuccess: operatorInfo => store.dispatch(setConfig({operatorInfo})),
    });
}

if (isConnected()) {
    performOperatorInfoRequest();
}

onConnect(performOperatorInfoRequest);
onDisconnect(() => {
    api.cancelOperatorInfoRequest(operatorInfoCallId);
    //clear OperatorInfo
    store.dispatch(setConfig({operatorInfo: undefined}));
});



// WEBPACK FOOTER //
// ./src/OMFECore/webapi.js